import {Component, Input} from '@angular/core';
import {Message} from "../../../models/message";
import {MessageService} from "../../../services/message/message.service";
import * as moment from "moment/moment";
import {Router} from "@angular/router";

@Component({
  selector: 'ui-messages-inbox',
  templateUrl: './messages-inbox.component.html',
  styleUrls: ['./messages-inbox.component.scss']
})
export class MessagesInboxComponent {

  @Input('messages') messages: Message[] = [];
  // @Input('menuSelected') menuSelected: number = 0;

//  messages: Message[] = [];
  selectedMessages: Message[] = [];


  constructor(public router: Router, public messageService: MessageService) {  }


  async ngOnInit() {

  }

  isSent(message: Message): boolean {
    return message.recipientsCount != null;
  }

  recipientIcon(message: Message): string {
    return message.recipientType === 'user' ? 'bi-person' : message.recipientType === 'category' ? 'bi-folder2' : 'bi-people';
  }

  senderName(message: Message): string {
    return `${message.createdBy?.firstName ?? ''} ${message.createdBy?.lastName ?? ''}`.trim() || 'Welldone';
  }

  senderInitial(message: Message): string {
    return this.senderName(message).charAt(0).toUpperCase();
  }

  formatMessageTime(createdAt: string | undefined) {
    const messageTime = moment(createdAt);
    const today = moment(new Date() );

    if (messageTime.isSame(today, 'days')) {
      return messageTime.format('HH:mm');
    } else {
      return messageTime.format('DD/MM/YYYY');
    }

  }

  readMessage(message: Message) {
    // Optimistic: the cached list shows it as read on return; the request runs in the background
    if (!message.seen && !this.isSent(message)) {
      message.seen = 1;
      void this.messageService.markMessageAsSeen(message.id!);
    }
    this.router.navigate(['/users/messages', message.id]);
  }
}
